import { Button, Card, Col, Flex, Form, Input, Row, Space, Tag, Typography, theme } from 'antd';
import { FC } from 'react';
import { ButtonSuccess, CopyableText } from '../../../../../../../../common/components';
import { AppFormProps } from '../../../../../../../../common/interfaces';
import { defineInputStatus } from '../../../../../../../../common/utils';
import {
  SearchConsoleAccountsFormSecondStepFields,
  SearchConsoleAccountsFormSecondStepInputs
} from '../../../../../searchConsole.interfaces';

interface Props extends AppFormProps<
  typeof SearchConsoleAccountsFormSecondStepInputs,
  SearchConsoleAccountsFormSecondStepFields
> {
}

export const SecondStepView: FC<Props> = ({
  formName,
  formType,
  form,
  initialValues,
  formErrors,
  isFormLoading,
  validationSchema,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  const { token } = theme.useToken();

  return (
    <Row gutter={ [0, 16] }>
      <Col span={ 24 }>
        <Card style={{ backgroundColor: token.colorBgLayout, outline: `2px dashed ${ token.colorBorder }`, outlineOffset: -8 }}>
          <Flex align="center" justify="center" wrap="wrap" vertical gap={ 8 } style={{ textAlign: 'center', whiteSpace: 'normal' }}>
            <Button
              type="primary"
              size="small"
              target="_blank"
              href="https://console.cloud.google.com/apis/dashboard"
            >
              Перейдіть в консоль Google Cloud
            </Button>
            <span style={{ whiteSpace: 'normal' }}>Додайте APIs <b>Google&nbsp;Search&nbsp;Console</b>, <b>Indexing</b> та <b>Site&nbsp;Verification</b></span>
            <span>Налаштуйте <b>OAuth&nbsp;consent&nbsp;screen</b></span>
            <span>
              Додайте <b>OAuth&nbsp;client&nbsp;ID</b>, в полі <b>Authorized&nbsp;redirect&nbsp;URIs</b>
              &#20;вкажіть такий URL:&#20;
            </span>
            <CopyableText textToCopy={ import.meta.env.VITE_SC_GOOGLE_OAUTH_TOKEN_URL }>
              <Tag style={{ width: 300 }}><Typography.Paragraph
                style={{ margin: 0 }}
                ellipsis={{
                  rows: 1,
                  tooltip: {
                    placement: 'top',
                    overlayStyle: { minWidth: 'max-content' }
                  }
                }}>{ import.meta.env.VITE_SC_GOOGLE_OAUTH_TOKEN_URL }</Typography.Paragraph></Tag>
            </CopyableText>
            <span>Після створення скопіюйте поля <b>Client&nbsp;ID</b> та <b>Client&nbsp;secret</b>, та вставте їх сюди</span>
          </Flex>
        </Card>
      </Col>

      <Col span={ 24 }>
        <Form
          form={ form }
          name={ formName }
          layout="vertical"
          initialValues={ initialValues }
          disabled={ isFormLoading }
          autoComplete="off"
          onFinish={ handleFinish }
          onFinishFailed={ handleFinishFailed }
        >
          <Form.Item
            label="ID клієнту"
            name={ SearchConsoleAccountsFormSecondStepInputs.ClientId }
            hasFeedback
            help={ formErrors?.clientId }
            validateStatus={ defineInputStatus(isFormLoading, formErrors?.clientId) }
            rules={ validationSchema.clientId }
          >
            <Input allowClear/>
          </Form.Item>

          <Form.Item
            label="Секретна фраза"
            name={ SearchConsoleAccountsFormSecondStepInputs.ClientSecret }
            hasFeedback
            help={ formErrors?.clientSecret }
            validateStatus={ defineInputStatus(isFormLoading, formErrors?.clientSecret) }
            rules={ validationSchema.clientSecret }
          >
            <Input allowClear/>
          </Form.Item>

          <Form.Item wrapperCol={{ span: 24 }}>
            <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
              <Button type="default" onClick={ handleBack }>
                { formType === 'edit' ? 'Скасувати' : 'Пізніше' }
              </Button>
              <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
                { formType === 'edit' ? 'Зберегти та вийти' : 'Далі' }
              </ButtonSuccess>
            </Space>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};
